// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1JPSQ","signatureBlock":"Footer_signatureBlock__2HDiU","signature":"Footer_signature__31aVc"};